import { parseAsArrayOf, parseAsStringLiteral, useQueryState } from 'nuqs'
import {
  SelectableColumns,
  selectableColumns,
} from '../components/NotificationTasksTable/ColumnsFilter/columns'

export const useSelectedColumnsQueryState = () => {
  const selectedColumnsParser = parseAsStringLiteral(
    selectableColumns.map((column) => column.id)
  )

  return useQueryState(
    'selected-columns',
    parseAsArrayOf<SelectableColumns>(selectedColumnsParser).withDefault([
      'status',
      'eventName',
      'eventId',
      'replay',
      'createdAt',
      'updatedAt',
      'payload',
    ])
  )
}
